function init() {

	$('.story-single__gallery .radio-tabs').on('change', (event) => {

		$(event.target).closest('.story-single__gallery').attr('data-size', event.target.value);

	});

	$('.story-single__gallery').on('click', 'figure button', (event) => {

		const $excerpt = $(event.target).closest('div');

		$excerpt.remove();

	});

	$('.story-single__gallery-continues').on('click', 'button', (event) => {

		$(event.target).closest('.story-single__gallery').find('.story-single__gallery-item').removeClass('gallery-item--continues');
		$(event.delegateTarget).hide();

	});


}

export default {
	init
};
